class QuickLinks extends HTMLElement {
  constructor() {
    super();
    this.scroller = this.querySelector('.quick-links--scroll');
    this.prevButton = this.querySelector('.slider-button--prev');
    this.nextButton = this.querySelector('.slider-button--next');
  }

  connectedCallback() {
    this.prevButton.addEventListener('click', () => this.scrollToEdge('start'));
    this.nextButton.addEventListener('click', () => this.scrollToEdge('end'));
    this.scroller.addEventListener('scroll', this.updateButtons.bind(this), { passive: true });

    this.resizeObserver = new ResizeObserver(this.updateButtons.bind(this));
    this.resizeObserver.observe(this);
    this.resizeObserver.observe(this.scroller);

    window.addEventListener('load', this.updateButtons.bind(this));
    this.updateButtons();
  }

  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }

  isOverflowing() {
    return this.scroller.scrollWidth > this.scroller.clientWidth + 1;
  }

  scrollToEdge(edge) {
    this.scroller.scrollTo({
      left: edge === 'end' ? this.scroller.scrollWidth : 0,
      behavior: 'smooth',
    });
  }

  updateButtons() {
    if (!this.isOverflowing()) {
      this.prevButton.hidden = true;
      this.nextButton.hidden = true;
      return;
    }
    const { scrollLeft, scrollWidth, clientWidth } = this.scroller;
    this.prevButton.hidden = scrollLeft <= 1;
    this.nextButton.hidden = scrollLeft + clientWidth >= scrollWidth - 1;
  }
}

customElements.define('quick-links', QuickLinks);